import React from 'react'
import { Button } from '@material-ui/core'
import { COLORES } from '../../../../config/colores'
import RepeatIcon from '@material-ui/icons/Repeat'

function VolverALeer (props) {
  const { deleteCpe, cpe } = props

  return (
    <Button
      variant='outlined'
      size='small'
      style={{
        margin: '4% auto',
        width: '98%',
        display: 'flex',
        alignItems: 'center',
        color: COLORES.grey.dark,
        backgroundColor: COLORES.grey.light,
        border: 'none',
        borderRadius: '8px'
      }}
      onClick={() => { deleteCpe(cpe.numero) }}
    >
      <RepeatIcon style={{ fontSize: '1.8rem' }} />
      <h6 style={{ margin: '0 8px' }}>Volver a leer</h6>
    </Button>

  )
}

export default VolverALeer
